import Link from "next/link";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import useTrans from "@/hooks/useTrans";
import styles from "./notFound.module.scss";

export default function NotFound() {
  const trans = useTrans();
  const router = useRouter();
  // A tab opened straight on the broken URL has nowhere to go back to.
  const [canGoBack, setCanGoBack] = useState(false);

  useEffect(() => {
    setCanGoBack(window.history.length > 1);
  }, []);

  return (
    <section className={styles.wrapper} aria-labelledby="not-found-title">
      <div className={styles.content}>
        <p className={styles.code} aria-hidden="true">
          404
        </p>
        <h1 id="not-found-title" className={styles.title}>
          {trans.notFound.title}
        </h1>
        <p className={styles.description}>{trans.notFound.description}</p>
        {router.asPath && router.asPath !== "/404" && (
          <p className={styles.path}>
            <code>{router.asPath}</code>
          </p>
        )}
        <div className={styles.actions}>
          <Link href="/" className={styles.primary}>
            {trans.notFound.backHome}
          </Link>
          {canGoBack && (
            <button
              type="button"
              className={styles.secondary}
              onClick={() => router.back()}
            >
              {trans.notFound.goBack}
            </button>
          )}
        </div>
      </div>
    </section>
  );
}
